import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation(); 
  return (
    <footer className="bg-white border-t border-gray-200 py-4">
      <div className="container mx-auto px-4">
        <div className="flex justify-center items-center">
          <p className="text-sm text-gray-600 text-center">
            &copy; {new Date().getFullYear()} {t('footer')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;